<template>
	<Row class="footer-container flex-align-center flex-justify-space-between">
		<v-checkbox class="checkbox" :ripple="false" dense color="primary" v-model="notifyByMailLocal">
			<template v-slot:label>
				<h3 class="reg">Notify users by email</h3>
			</template>
		</v-checkbox>
		<AppTooltip :disabled="!isShareButtonDisabled" :text="shareButtonDisabledExplanationText">
			<AnemicButton
				tile
				:loading="isLoading"
				@click="$emit('share')"
				class="pa-0 share-button"
				:disabled="isShareButtonDisabled || isLoading"
			>
				Share
			</AnemicButton>
		</AppTooltip>
	</Row>
</template>
<script>
export default {
	name: 'BeforeShareFooter',
	props: {
		isLoading: { type: Boolean },
		notifyByMail: { type: Boolean },
		isShareButtonDisabled: { type: Boolean },
	},
	computed: {
		shareButtonDisabledExplanationText() {
			return 'To share, please address the required changes';
		},
		notifyByMailLocal: {
			get() {
				return this.notifyByMail;
			},
			set(value) {
				this.$emit('update:notifyByMail', value);
			},
		},
	},
};
</script>
<style scoped lang="scss">
.footer-container {
	border-top: 1px solid #e7e7ed;
	::v-deep {
		.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
			font-weight: normal !important;
			color: var(--white) !important;
			background: #bcbcf7 !important;
		}
	}
}
.share-button {
	width: 150px !important;
	height: 45px !important;
	border-radius: 10px !important;
	letter-spacing: 0px !important;
	color: var(--white) !important;
	font-size: 14px !important;
	font-weight: normal !important;
	background: var(--bold-border-color) !important;
	border: 1px solid var(--bold-border-color) !important;
	&:disabled {
		border: unset !important;
		background: #bcbcf7 !important;
		background-color: red !important;
	}
}
.checkbox {
	padding-top: 16px;
}
</style>
